var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResponsive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.998 511.998",
    style: {
      enableBackground: "new 0 0 511.998 511.998"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCD8E5"
    },
    d: "M503.662,56.081v316.341c0,17.908-14.509,32.428-32.417,32.428H40.755 c-17.908,0-32.417-14.52-32.417-32.428V56.081c0-17.908,14.509-32.428,32.417-32.428h430.49 C489.153,23.653,503.662,38.173,503.662,56.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFEAF4"
    },
    d: "M503.662,56.081v316.341c0,17.908-14.509,32.428-32.417,32.428H183.344l23.752-57.924L339.654,23.653 h131.591C489.153,23.653,503.662,38.173,503.662,56.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8E9F2"
    },
    d: "M503.662,56.081v290.845H8.338V56.081c0-17.908,14.509-32.428,32.417-32.428h430.49 C489.153,23.653,503.662,38.173,503.662,56.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4F7FC"
    },
    d: "M503.662,56.081v290.845H207.096L339.654,23.653h131.591 C489.153,23.653,503.662,38.173,503.662,56.081z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCD8E5"
    },
    points: "343.453,469.452 168.547,469.452 181.034,440.234 196.165,404.85 315.835,404.85  330.966,440.234 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAC6D1"
    },
    points: "330.966,440.234 181.034,440.234 196.165,404.85 315.835,404.85 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCD8E5"
    },
    d: "M454.542,237.484v232.409c0,11.598-9.399,20.997-20.997,20.997H312.23 c-0.689,0-1.355-0.033-2.022-0.1c-10.654-1.011-18.975-9.987-18.975-20.897V237.484c0-11.598,9.399-20.997,20.997-20.997h121.315 C445.143,216.488,454.542,225.886,454.542,237.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFEAF4"
    },
    d: "M454.542,237.484v232.409c0,11.598-9.399,20.997-20.997,20.997H312.23 c-0.689,0-1.355-0.033-2.022-0.1L422.68,216.488h10.865C445.143,216.488,454.542,225.886,454.542,237.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8E9F2"
    },
    d: "M454.542,237.484v202.303H291.234V237.485c0-11.598,9.399-20.997,20.997-20.997h121.315 C445.143,216.488,454.542,225.886,454.542,237.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4F7FC"
    },
    d: "M454.542,237.484v202.303H331.116l91.564-223.299h10.865 C445.143,216.488,454.542,225.886,454.542,237.484z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M471.24,14.053H40.749C18.281,14.053,0,32.332,0,54.802v59.224c0,4.602,3.731,8.332,8.332,8.332s8.332-3.731,8.332-8.332 V54.802c0-13.281,10.805-24.085,24.085-24.085h430.49c13.287,0,24.096,10.805,24.096,24.085v284.412h-32.462V236.204 c0-16.17-13.155-29.324-29.324-29.324H312.226c-16.17,0-29.324,13.155-29.324,29.324v159.036H40.749 c-13.28,0-24.085-10.805-24.085-24.085v-15.275H263.46c4.602,0,8.332-3.731,8.332-8.332s-3.731-8.332-8.332-8.332H16.664V141.8 c0-4.602-3.731-8.332-8.332-8.332S0,137.199,0,141.8v229.354c0,22.47,18.281,40.749,40.749,40.749h142.787l-20.495,47.948h-40.027 c-4.602,0-8.332,3.731-8.332,8.332c0,4.602,3.731,8.332,8.332,8.332h45.526h92.856h1.111c4.602,0,8.332-3.731,8.332-8.332 c0-4.602-3.731-8.332-8.332-8.332h-1.111h-80.233l14.241-33.317h87.497v42.086c0,16.17,13.155,29.324,29.324,29.324h121.323 c16.17,0,29.324-13.155,29.324-29.324V355.879h32.462v15.275c0,9.701-5.778,18.413-14.72,22.196 c-4.238,1.793-6.221,6.681-4.428,10.919c1.344,3.18,4.43,5.089,7.678,5.089c1.082,0,2.183-0.212,3.242-0.66 c15.121-6.396,24.892-21.132,24.892-37.543V54.802C512,32.332,493.715,14.053,471.24,14.053z M299.566,236.204 c0-6.981,5.679-12.66,12.66-12.66h121.323c6.981,0,12.66,5.679,12.66,12.66v193.975H299.564V236.204H299.566z M433.549,481.282 H312.226c-6.981,0-12.66-5.679-12.66-12.66v-21.779H446.21v21.779C446.21,475.602,440.531,481.282,433.549,481.282z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.924,368.954c-3.987-6.049-13.707-4.123-15.098,3c-0.672,3.439,0.933,7.043,3.962,8.811 c3.025,1.765,6.959,1.424,9.621-0.855C264.589,377.188,265.22,372.441,262.924,368.954z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M380.584,460.874c-1.324-3.138-4.479-5.226-7.901-5.138c-3.412,0.087-6.483,2.309-7.633,5.519 c-1.173,3.277-0.134,7.034,2.553,9.246c2.798,2.304,6.888,2.494,9.904,0.494C380.799,468.81,382.043,464.517,380.584,460.874z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M350.113,250.206h45.549c4.602,0,8.332-3.731,8.332-8.332s-3.731-8.332-8.332-8.332h-45.549 c-4.602,0-8.332,3.731-8.332,8.332S345.512,250.206,350.113,250.206z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/responsive.993e3969757a8b229affa7219f800459.svg";
export { ForwardRef as ReactComponent };